import { useEffect } from 'react'

/**
 * 弹层打开期间锁住背景滚动 —— **全站唯一一份实现**。
 *
 * 为什么必须共享：
 *   不锁的话，滚抽屉 / 滚放大遮罩会把底下那一层页面一起带着滚 ——
 *   关掉弹层之后发现自己已经不在原来的位置了，很难归因到这个弹层头上。
 *
 * 为什么是 hook 而不是各弹层自己写：`ImageLightbox` 与 `ui.tsx` 的 `Drawer`
 * 已经各抄过一遍，而且抄得不一致 —— 两个都锁了，唯独 `Modal`（居中弹窗，
 * 一样会带着背景滚）漏了。这就是「同一件事在两处各写一遍、第三处忘掉」的
 * 典型症状，所以收敛到一处。
 *
 * 注意是**挂载期间**锁、卸载还原，并把「原来是什么值」还原回去而不是硬置 `''`：
 * 万一将来有嵌套弹层，外层设的值不会被内层清掉。
 */
export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [active])
}
